export const Feature = {
	REVIEWS_WIDGET: "REVIEWS_WIDGET",
	REVIEWS_AUTO_REPLY: "REVIEWS_AUTO_REPLY",
	REPLY_TEMPLATES: "REPLY_TEMPLATES",
	CAMPAIGNS: "CAMPAIGNS",
	WHATSAPP_REVIEW_REQUEST: "WHATSAPP_REVIEW_REQUEST",
	USERS_REVIEW_HISTORY: "USERS_REVIEW_HISTORY",
	NPS_DASHBOARD: "NPS_DASHBOARD"	
}